import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
    deliveryFree: {
        id: 'listing.productCard.secondaryCharacteristic.free',
        defaultMessage: 'Free delivery',
        description: 'Free delivery label of the product card',
    },
    delivery24h: {
        id: 'listing.productCard.secondaryCharacteristic.delivery24h',
        defaultMessage: '24h delivery',
        description: '24h delivery label of the product card',
    },
    deliveryPayment: {
        id: 'listing.productCard.secondaryCharacteristic.deliveryPayment',
        defaultMessage: 'Delivery fee from {min_fee}{currency}',
        description: 'fee delivery label of the product card',
    },
    pro: {
        id: 'listing.productCard.secondaryCharacteristic.pro',
        defaultMessage: 'Selected for pros',
        description: 'Selected for pros label of the product card',
    },
    manomano: {
        id: 'listing.productCard.secondaryCharacteristic.manomano',
        defaultMessage: 'Delivered by ManoMano',
        description: 'Delivered by ManoMano label of the product card',
    },
});

export default function useSecondaryIcons(iconsObject) {
    const {
        isB2B,
        isProProduct,
        isMFProduct,
        hasOneDayDelivery,
        hasFreeDelivery,
        minFee,
        currency,
    } = iconsObject;
    const iconKeys = [];
    const intl = useIntl();

    if (Object.entries(iconsObject).length === 0) return iconKeys;

    if (hasFreeDelivery)
        iconKeys.push({
            icon: 'DeliveryFree',
            claim: intl.formatMessage(messages.deliveryFree),
        });
    else if (minFee) {
        iconKeys.push({
            icon: 'DeliveryPayment',
            claim: intl.formatMessage(messages.deliveryPayment, {
                min_fee: minFee,
                currency,
            }),
        });
    }

    if (hasOneDayDelivery)
        iconKeys.push({
            icon: 'Delivery24h',
            claim: intl.formatMessage(messages.delivery24h),
        });

    if (!isB2B && isProProduct)
        iconKeys.push({ icon: 'Pro', claim: intl.formatMessage(messages.pro) });

    if (isMFProduct && isB2B)
        iconKeys.push({
            icon: 'Manomano',
            claim: intl.formatMessage(messages.manomano),
        });

    return iconKeys;
}
